// @flow

import React from "react";
import { RtwReasonScope } from "@modules/service/components";

type Props = $Exact<{
  data: Object,
  schema: Object,
}>;

export class RtwReasonScopeView extends React.Component<Props> {
  get data() {
    return this.props.data.absenceReasons;
  }

  get schema() {
    const { absenceTypeScope } = this.props.data;

    let dependentSchema = null;
    if (this.props.schema && absenceTypeScope) {
      dependentSchema = this.props.schema.dependencies.absenceTypeScope.oneOf.find(
        o => (o.properties.absenceTypeScope || {}).const === absenceTypeScope,
      );
    }

    let absenceReasonWithMinItems = null;
    if (dependentSchema) {
      absenceReasonWithMinItems = {
        ...dependentSchema.properties.absenceReasons,
        minItems: 1,
        uniqueItems: true,
      };
    }

    let absenceReasonsItem = {};
    if (absenceReasonWithMinItems) {
      absenceReasonsItem = absenceReasonWithMinItems.items;
    }

    return (
      this.props.data.absenceReasons &&
      !!this.props.data.absenceReasons.length &&
      absenceReasonsItem
    );
  }

  render() {
    return <RtwReasonScope data={this.data} schema={this.schema} disabled />;
  }
}

export default RtwReasonScopeView;
